/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskBusinessName } from './ExecRiskBusinessName';
import {
    ExecRiskBusinessNameFromJSON,
    ExecRiskBusinessNameFromJSONTyped,
    ExecRiskBusinessNameToJSON,
} from './ExecRiskBusinessName';

/**
 * 
 * @export
 * @interface ExecRiskTransferSchedule
 */
export interface ExecRiskTransferSchedule {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskTransferSchedule
     */
    line_number?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskTransferSchedule
     */
    amount_involved?: string;
    /**
     * 
     * @type {ExecRiskBusinessName}
     * @memberof ExecRiskTransferSchedule
     */
    name_of_noncharitable_eo?: ExecRiskBusinessName;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskTransferSchedule
     */
    description_of_transfers_etc?: string;
}

/**
 * Check if a given object implements the ExecRiskTransferSchedule interface.
 */
export function instanceOfExecRiskTransferSchedule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskTransferScheduleFromJSON(json: any): ExecRiskTransferSchedule {
    return ExecRiskTransferScheduleFromJSONTyped(json, false);
}

export function ExecRiskTransferScheduleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskTransferSchedule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'line_number': !exists(json, 'line_number') ? undefined : json['line_number'],
        'amount_involved': !exists(json, 'amount_involved') ? undefined : json['amount_involved'],
        'name_of_noncharitable_eo': !exists(json, 'name_of_noncharitable_eo') ? undefined : ExecRiskBusinessNameFromJSON(json['name_of_noncharitable_eo']),
        'description_of_transfers_etc': !exists(json, 'description_of_transfers_etc') ? undefined : json['description_of_transfers_etc'],
    };
}

export function ExecRiskTransferScheduleToJSON(value?: ExecRiskTransferSchedule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'line_number': value.line_number,
        'amount_involved': value.amount_involved,
        'name_of_noncharitable_eo': ExecRiskBusinessNameToJSON(value.name_of_noncharitable_eo),
        'description_of_transfers_etc': value.description_of_transfers_etc,
    };
}

